import { IAquisicao, IAquisicaoListagemResumo } from '../interfaces/IAquisicao';

/**
 * Organiza as aquisicoes de uma declaração para ser exibida no resumo
 *
 * @param arrematacoes Aquisicoes de uma declaração
 * @returns {IAquisicaoListagemResumo} Aquisições listadas de forma resumida
 */
export const aquisicoesTotais = (aquisicoes: IAquisicao[]) => {
  const novaListagemData: IAquisicaoListagemResumo[] = [];
  aquisicoes.forEach((aquisicao) => {
    const indiceListagem = novaListagemData.findIndex(
      (item) =>
        item.numeroProcesso === aquisicao.numeroProcesso &&
        item.municipio.nome === aquisicao.municipio.nome &&
        item.substancia === aquisicao.substancia &&
        item.estabelecimentoAdquirente === aquisicao.estabelecimentoAdquirente
    );
    if (indiceListagem === -1) {
      novaListagemData.push({
        numeroProcesso: aquisicao.numeroProcesso,
        municipio: {
          nome: aquisicao.municipio.nome,
          codigoIBGE: aquisicao.municipio.codigoIBGE,
          uf: aquisicao.municipio.uf,
        },
        substancia: aquisicao.substancia,
        estabelecimentoAdquirente: aquisicao.estabelecimentoAdquirente,
        aquisicao: aquisicao,
        totais: {
          valorTotalDeOperacao: aquisicao.valorTotal,
          quantidadeTotal: aquisicao.quantidadeTotal,
        },
      });
    } else {
      const valorOperacao = parseFloat(novaListagemData[indiceListagem].totais.valorTotalDeOperacao);
      const quantidade = novaListagemData[indiceListagem].totais.quantidadeTotal;

      novaListagemData[indiceListagem].totais.valorTotalDeOperacao = (
        valorOperacao + parseFloat(aquisicao.valorTotal)
      ).toString();

      novaListagemData[indiceListagem].totais.quantidadeTotal = quantidade + aquisicao.quantidadeTotal;
    }
  });
  return novaListagemData;
};
